import { useEffect, useState } from 'react';

export type TabletOrientation = 'portrait' | 'landscape';

function read(): TabletOrientation {
  if (typeof window === 'undefined') return 'landscape';
  return window.innerHeight >= window.innerWidth ? 'portrait' : 'landscape';
}

export function useTabletOrientation(): TabletOrientation {
  const [orientation, setOrientation] = useState<TabletOrientation>(() => read());
  useEffect(() => {
    const onResize: () => void = () => setOrientation(read());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return orientation;
}
